import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import './style.css';

const ThemeToggle = () => {
    const [isDark, setIsDark] = useState(false);

    // Carica il tema salvato al mount del componente
    useEffect(() => {
        const savedTheme = localStorage.getItem('theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        const initialDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
        setIsDark(initialDark);
        applyTheme(initialDark);
    }, []);

    // Applica o rimuove la classe dark-theme-active
    const applyTheme = (dark) => {
        const htmlElement = document.documentElement; // <html> tag
        if (htmlElement) {
            if (dark) {
                htmlElement.classList.add('dark-theme-active')
                htmlElement.setAttribute('data-bs-theme', 'dark')
            } else {
                htmlElement.classList.remove('dark-theme-active')
                htmlElement.setAttribute('data-bs-theme', 'light')
            }
        }
    };

    // Toggle del tema
    const toggleTheme = () => {
        const newDark = !isDark;
        setIsDark(newDark);
        applyTheme(newDark);
        
        // Salva la preferenza nel localStorage
        localStorage.setItem('theme', newDark ? 'dark' : 'light');
    };

    return (
        <Button
            variant="outline-light"
            size="sm"
            onClick={toggleTheme}
            className="theme-toggle-btn me-2"
            title={isDark ? 'Passa al tema chiaro' : 'Passa al tema scuro'}
        >
            <FontAwesomeIcon 
                icon={isDark ? faSun : faMoon} 
                className="theme-toggle-icon"
            />
        </Button>
    );
};

export default ThemeToggle;